import Vue from "vue";
import { CopyrightPlacement, Provider } from "js/crossword/types";
import { Puzzle } from "js/crossword/Puzzle";
import { getCopyrightData } from "js/crossword/helpers/copyright";
import OS from "framework/utils/OS";
import PopupButtons from "./PopupButtons";
import PopupContainer from "./PopupContainer";

import styles from "../css/WelcomePopup.module.css";

export default Vue.extend({
  inject: [Provider.LOCALIZATION],
  props: {
    gameTitle: String,
    puzzle: Puzzle,
  },
  render() {
    const { author, date } = this.puzzle.data.metaData;
    const copyright = getCopyrightData(this.puzzle.data.metaData.format);

    return (
      <PopupContainer customClasses={[styles.main]}>
        <div style="text-align: center">
          {this.localization.get("Welcome to our new")}
          <div class={styles.title}>{this.gameTitle}</div>
        </div>

        <div class={styles.content}>
          <img
            class={[styles.icon, !OS.desktop ? styles.icon_mobile : ""]}
            src="images/Welcome_Icon.png"
          />
          <div>
            <puzzle-date date={date} style="text-align: left"></puzzle-date>
            {author
              ? <div class={styles.author}>
                {this.localization.get("by")}
                    &nbsp;{author}
              </div>
              : null}
            {copyright.placement === CopyrightPlacement.WELCOME
              ? <div class={[styles.copyright, !OS.desktop ? styles.copyright_mobile : ""]} >
                {copyright.message}
              </div>
              : null}
          </div>
        </div>

        <PopupButtons buttons={[{
          label: this.localization.get("Play"),
          onClick: () => {
            if (!OS.desktop) {
              document.body.style.overflowY = 'scroll';
            }
            this.$emit("close");
          },
        }]} />
      </PopupContainer>
    );
  },
});
